import React, { Children } from 'react';

import { Container } from 'components/container/Container';
import { SectionHeader } from 'components/section-header/SectionHeader';

import s from './Grid.scss';

interface IProps {
  heading?: string;
  link?: string;
  linkText?: string;
  children: Array<React.ReactElement<any>> | React.ReactNode;
  isColumnLayout?: boolean;
  limitColumns?: boolean; // limit to 2 columns in column layout
  columns?: 2 | 3 | 4; // 4 only at page-limit
}

export const Grid = ({
  children,
  heading,
  link,
  linkText,
  columns = 3,
  isColumnLayout = false,
  limitColumns = isColumnLayout,
}: IProps) => {
  const childCount = Children.count(children);

  if (childCount === 0) {
    return null;
  }

  const Wrapper = isColumnLayout ? 'div' : Container;

  return (
    <section className={
      s('grid',
      `count${childCount}`,
      `columns${columns}`,
        { isColumnLayout, defaultColumns: !limitColumns, hasHeading: heading }
      )}>
      <Wrapper>
        <div className={s.grid__inner}>
          {(link || heading) && <SectionHeader heading={heading} link={link} linkText={linkText} />}

          <ul className={s.grid__row}>
            {React.Children.map(children, child => (
              <li className={s.grid__item}>{child}</li>
            ))}
          </ul>
        </div>
      </Wrapper>
    </section>
  );
};
